// NOTE: \p{L} is an expression to match all characters from all languages.
export const AlphabeticRegex = "^([\\p{L}'.,\\-\\s\\/]+)$";
export const AlphanumericRegex = "^[\\p{L}0-9'\\-\\s\\.]+$";
export const AlphanumericRegexAllowEmpty = "^[\\p{L}0-9'\\-\\s\\.,;:?!\\(\\)]*$";
export const HtmlTagsRegex = /(<([^>]+)>)/gi;
export const NoSpacesRegex = "^[^ ]+$";